import Vue from 'vue'
import App from './App'
import {
    router
} from './router/index'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
// import './styles/element-variables.scss'
import 'font-awesome/css/font-awesome.min.css'
import './utils/filter_utils.js'
import store from './store'


import VueRouter from 'vue-router'
Vue.use(VueRouter)
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
Vue.config.productionTip = false

// 定义一个过滤器 处理时间
Vue.filter('dateFormat', function(originVal) {
    const dt = new Date(originVal)
    const y = dt.getFullYear()
        // 月份从0开始,使她变成字符串,不足两位时,前面补个0.
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')
    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})


const vue = new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
})
window.bus = vue


// WEBPACK FOOTER //
// ./src/main.js